import { message } from 'antd';
import commonApi from 'apis/common';
import { uploadOrderFile } from 'apis/oms';
import LOCALS from 'commons/locals';
import i18n from 'i18n';
import { isAllowedReceiptImageType } from 'utils/receipt-image-upload';

/** 订单票据：走 /admin/order/:id/upload-file，写入 images/order/{id}/{hash} */
export const uploadOrderReceiptImageFile = async (
  orderId: number,
  file: File,
): Promise<string | null> => {
  if (!isAllowedReceiptImageType(file.type)) {
    message.error(i18n.t(LOCALS.payment_receipt_image_invalid_type));
    return null;
  }

  try {
    const up = await uploadOrderFile(orderId, file);
    return up.key;
  } catch {
    return null;
  }
};

/** 订单备注附图，返回逗号拼接的 key 与签名 url */
export const uploadOrderImageFiles = async (
  orderId: number,
  files: File[],
): Promise<{ keys: string; urls: string }> => {
  const uploadedList = await Promise.all(
    files.map(async (file) => {
      const uploaded = await uploadOrderFile(orderId, file);
      const signed = await commonApi.getSignedFileUrl(uploaded.key);
      return { key: uploaded.key, url: signed.url || uploaded.url };
    }),
  );

  return {
    keys: uploadedList.map((item) => item.key).join(','),
    urls: uploadedList.map((item) => item.url).join(','),
  };
};
